import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Campaign = {
  Helmet: lazy(() => import('./components/CampaignHelmet.tsx')),
  Overview: {
    Component: lazy(() => import('./scenes/Overview/index.tsx')),
    Providers: lazy(() => import('./scenes/Overview/Providers.tsx')),
  },
  Edit: lazyNamed(() => import('./scenes/BookingTool/containers/CampaignEdit/index.tsx'), 'CampaignEdit'),
  DocumentPreview: lazy(() => import('./scenes/BookingTool/containers/CampaignPreview/index.tsx')),
  EditPositions: lazy(() => import('./scenes/BookingTool/containers/CampaignPositionsEdit/index.tsx')),
  History: lazy(() => import('./scenes/History/index.tsx')),
  FiltersProvider: lazy(() => import('src/modules/CampaignFilters/RouteLayout.tsx')),
  EditPermissionChecker: lazyNamed(() => import('./components/EditPermissionChecker.tsx'), 'EditPermissionChecker'),
};

export default Campaign;
